<template>
  <div class="uk-width-medium@m">
    <v-select
      ref="select"
      append-to-body
      v-model="selected"
      :options="merchants"
      :filterable="false"
      @search="onSearch"
      label="company"
      @input="onMerchantSelect"
      placeholder="Händler"
    >
      <template #spinner="{ loading }">
        <div
          v-if="loading"
          class="vs__spinner"
        ></div>
      </template>
      <template slot="option" slot-scope="option">
        {{ option.company }}<br />
        <span class="uk-text-small uk-text-light">
          #{{ option.number }} - {{ option.zipcode }} {{ option.city }}
        </span>
      </template>
      <template v-slot:no-options>
        Tippen zum Suchen...
      </template>
    </v-select>
  </div>
</template>
<script>
import _ from 'lodash'
import axios from 'axios'
import Configuration from '@/configuration';
export default {
  props: {
    value: {
      required: false
    },
    updateRoute: {
      required: false,
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      merchants: [],
      selected: null
    }
  },
  methods: {
    onMerchantSelect() {
      this.selected = _(this.selected)
        .omitBy(_.isNull)
        .omit('query')
        .value()

      if (this.updateRoute) {
        this.$router.replace({
          query: {
            merchantNumber: this.selected.number,
            page: 1
          }
        })
      }
      this.$emit('selected', this.selected)
    },
    onSearch(search, loading) {
      if (search.length === 0) {
        return
      }
      loading(true)
      this.search(loading, search, this)
    },
    search: _.debounce((loading, search, vm) => {
      axios
        .get(`${Configuration.value('apiBackend')}/merchant/search?q=${escape(search)}`)
        .then(res => {
          vm.merchants = res.data
          loading(false)
        })
    }, 350)
  }
}
</script>
